module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av108-fd15a375687f6a01d989cfc286d35ab2.jpg";